import { render, staticRenderFns } from "./Dpc.vue?vue&type=template&id=5a83e009&"
import script from "./Dpc.vue?vue&type=script&lang=js&"
export * from "./Dpc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports